module.exports = __webpack_public_path__ + "static/media/ourStory.d01f9d27.jpg";